const clientConfirmMixin = {
    methods: {
        // Before adding an item "as <chosen client>", confirm only when it makes sense.
        // Returns true when it's safe to proceed:
        //   - the user has no intranet linkage at all (null / undefined / false / []), or
        //   - the chosen client is the user themselves, or
        //   - the user explicitly confirmed the dialog.
        async confirmAddAsChosenClient() {
            const intranetIds = this.$store.state.auth.user.intranet_id;

            // No intranet linkage → nothing to confirm, just proceed
            if (!Array.isArray(intranetIds) || intranetIds.length === 0) {
                return true;
            }

            const chosenClient = this.$store.state.auth.chosenClient;
            const isChosenClientSelf = intranetIds.some(
                (item) =>
                    item.intranet_id === chosenClient.intranet_id &&
                    item.alliance === chosenClient.alliance
            );
            if (isChosenClientSelf) {
                return true;
            }

            const result = await this.$swal.fire({
                icon: 'question',
                title: this.$t('general.different_intranet_id_title'),
                text: this.$t('general.different_intranet_id_text', { name: chosenClient.name }),
                showCancelButton: true,
                cancelButtonText: this.$t('general.no'),
                confirmButtonText: this.$t('general.yes'),
            });

            return result.isConfirmed;
        },
    },
};

export default clientConfirmMixin;
